import React, { Component } from "react";
import * as Log from "../../common/Feedback/Log";
import { DisplayType } from "./Statistics/ChartObjects";
import Chart from "react-google-charts";
import * as WebDataRocksReact from "../../webdatarocks.react";

export class BPMStatistics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: []
    };

    this.logger = Log;
  }

  processDisplayType = type => {
    if (type === DisplayType.CHART) {
      return this.processChart();
    }
    if (type === DisplayType.TABLE) {
      return this.processTable();
    }
    if (type === DisplayType.TABLECHART) {
      return this.processTableAndChart();
    }
  };

  processTable = () => {
    console.log(this.props);
    if (this.props.visible === false) {
      return <React.Fragment></React.Fragment>;
    }
    return (
      <span className="p-float-label">
        <WebDataRocksReact.Pivot
          toolbar={true}
          report={{
            dataSource: {
              dataSourceType: "inlineJSON",
              data: this.props.tableData
            },
            slice: {
              rows: [
                {
                  uniqueName: "Product"
                }
              ],
              columns: [
                {
                  uniqueName: "[Measures]"
                }
              ],
              measures: [
                {
                  uniqueName: "Expected"
                },
                {
                  uniqueName: "Actual"
                }
              ]
            }
          }}
        />
      </span>
    );
  };
  processChart = () => {
    console.log(this.props);
    if (this.props.visible === false) {
      return <React.Fragment></React.Fragment>;
    }
    return (
      <span className="p-float-label">
        <Chart
          chartType={this.props.chartType}
          loader={<div>Loading Chart</div>}
          columns={this.props.chartData.columns}
          rows={this.props.chartData.rows}
          options={this.props.chartOptions}
          legendToggle
        />
      </span>
    );
  };
  render() {
    return <div>{this.processDisplayType(this.props.displayType)}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/BPMChart.js